import "./Home.module.css";
import Pagemaker24Navigation from "@/reusable_sections/Header";
import EinfachZumErfolg from "./sections/EinfachZumErfolg";
import OurDesignPhilosophy from "./sections/OurDesignPhilosophy";
import InspirierendeKmuBeispiele from "./sections/InspirierendeKmuBeispiele";
import OurSuccessNumbers from "./sections/OurSuccessNumbers";
import GlobaleEngineeringStandards from "./sections/GlobaleEngineeringStandards";
import DigitaleLoesungenBranding from "./sections/DigitaleLoesungenBranding";
import ScaleAndIntegrate from "./sections/ScaleAndIntegrate";
import CustomerMoments from "./sections/CustomerMoments";
import OptimierungStarten from "./sections/OptimierungStarten";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Pagemaker24Navigation />
      <EinfachZumErfolg />
      <OurDesignPhilosophy />
      <InspirierendeKmuBeispiele />
      <OurSuccessNumbers />
      <GlobaleEngineeringStandards />
      <DigitaleLoesungenBranding />
      <ScaleAndIntegrate />
      <CustomerMoments />
      <OptimierungStarten />
      <Footer />
    </div>;
}